import { Component, inject } from '@angular/core';
import { DashboardRoutingModule } from '../../pages/user-management/dashboard/dashboard/dashboard-routing-module';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { NAVIGATION } from '../../core/navigation/navigation.config';
import { UserRole } from '../../shared/model/role';
import { AccordionModule } from 'primeng/accordion';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sub-menu',
  imports: [DashboardRoutingModule, AccordionModule, CommonModule],
  templateUrl: './sub-menu.html',
  styleUrl: './sub-menu.scss',
})
export class SubMenu {
  currentParent: any;
  private sub!: Subscription;
  role: UserRole = UserRole.ADMIN;
  tabs = [
    { title: 'Title 1', content: 'Content 1' },
    { title: 'Title 2', content: 'Content 2' },
    { title: 'Title 3', content: 'Content 3' }
  ];
  selectedSubmenu: string = ''
  accordionValue: string | null = null;


  constructor(private router: Router) { }

  ngOnInit() {
    this.role = this.getRole();
    this.resolveParent(); // initial load
    this.sub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.resolveParent());
  }

  private resolveParent() {
    const navItems = NAVIGATION();
    const currentUrl = this.router.url.split('?')[0];


    // find matching top-level parent by prefix
    this.currentParent = navItems.find(item =>
      currentUrl === '/' + item.route ||
      currentUrl.startsWith('/' + item.route + '/')
    );
    // Find selected submenu
    if (this.currentParent?.children) {

      const selectedChild = this.currentParent.children.find(
        (child: any) => {
          const childRoute = child.route.replace(/\/$/, '');
          const url = currentUrl.replace(/\/$/, '');

          return (
            url === childRoute ||
            url.startsWith(childRoute + '/')
          );
        }
      );

      this.selectedSubmenu = selectedChild?.label ?? '';
    }
  }

  private getRole(): UserRole {
    const roleStr = localStorage.getItem('userRole');
    return roleStr as UserRole || UserRole.USER;
  }

  onSelection(label: string) {
    this.accordionValue = null;
  }

  onAccordionSelection(value: any) {
    this.accordionValue = value;
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
